import { CloudOff, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useOnlineStatus } from '@/offline/useOnlineStatus.ts';
import { usePendingWrites } from '@/offline/usePendingWrites.ts';

/**
 * What the user needs to know, in the order they need to know it.
 *
 * Unsynced writes come FIRST, and being offline is only shown when there is
 * nothing waiting. The reason: "offline" invites the reading "it did not save",
 * which is false — Firestore queued it and it is durable — and someone who
 * believes it types the weight in again. "Saved, not yet synced" is both true
 * and actionable; a bare network icon is neither.
 */
export const SyncStatus = () => {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  const pending = usePendingWrites();

  if (pending) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-due">
        <RefreshCw className="size-3.5 animate-spin" aria-hidden />
        {t('common.unsynced')}
      </span>
    );
  }

  if (!online) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-ink-faint">
        <CloudOff className="size-3.5" aria-hidden />
        {t('common.offline')}
      </span>
    );
  }

  return null;
};
